import * as THREE from 'three';

const bilateralVertexShader = `
varying vec2 vUv;

void	main ()
{
	vUv = position.xy * 0.5 + 0.5;
	gl_Position = vec4(position.xy, 1.0, 1.0);
}
`;

const bilateralFragmentShader = `
/****************************************************/
#include <packing>

// #ifdef FRAMEBUFFER_PRECISION_HIGH

// uniform mediump sampler2D ColorTexture;
// uniform mediump sampler2D DepthTexture;

// #else
// uniform lowp sampler2D ColorTexture;
// uniform lowp sampler2D DepthTexture;

// #endif

uniform sampler2D ColorTexture;
uniform sampler2D DepthTexture;

uniform	vec2    SreenSize;
uniform	int		  NHalf;					//	half filter size (<= 7!)
uniform float		DistCoefs[64];			//	pixel distance based damping coefs (max = 8*8).
uniform float		SigmaDepth;				//  pixel depth distribution variance

uniform int			PerspectiveMode;		// whether perspective mode is enabled (1) or not (0) - for z-Buffer compensation
uniform float		Znear;                  // minimal depth in image
uniform float		Zfar;				    // maximal depth in image

varying vec2 vUv;

/****************************************************/

float fixDepth2( float fragCoordZ ) {
  //return fragCoordZ;
	if (PerspectiveMode == 1)	{
        float viewZ = perspectiveDepthToViewZ( fragCoordZ, Znear, Zfar );
        return viewZToOrthographicDepth( viewZ, Znear, Zfar );
        //return viewZ;
  }
  return fragCoordZ;
}

void main (void)
{
  vec2 xy = vUv.st;

  // gl_FragColor.rgb = texture2D(ColorTexture, xy).rgb;
  // gl_FragColor.a = 1.0;
  // return;

  // float dd = fixDepth2(texture2D(DepthTexture, xy).r);
  // gl_FragColor.rgb = vec3(dd,dd,dd);
  // gl_FragColor.a = 1.0;
  // return;

  // if (isEnabled == 0) {
  //   gl_FragColor.rgb = texture2D(ColorTexture, xy).rgb;
  //   gl_FragColor.a = 1.0;
  //   return;
  // }

	float	z		= fixDepth2(texture2D(DepthTexture, xy).r);
  //float	z		= texture2D(DepthTexture, xy).r;

	float	wsum	=	0.0;				// sum of all weights
	vec3	csum	=	vec3(0.0);			// sum of all contributions
	vec2	coordi	=	vec2(0.0, 0.0);		// ith neighbor position

	for(int c=-NHalf; c<=NHalf; c++)
	{
		//neighbor position (X)
    coordi.x = float(c) / SreenSize.x;
		int cabs;
		if (c < 0)
			cabs = -c;
		else
			cabs = c;

    for(int d=-NHalf; d<=NHalf; d++)
    {
      //neighbor position (Y)
      coordi.y    = float(d) / SreenSize.y;

      //neighbor color
      vec3 ci	=	texture2D(ColorTexture, xy + coordi).rgb;

      //pixel distance based damping
      int dabs;
      if (d < 0) {
        dabs = -d;
      }else{
        dabs = d;
      }
      float fi	=	DistCoefs[cabs * (NHalf + 1) + dabs];

      //pixel depth difference based damping
      if (SigmaDepth > 0.0)
      {
        //neighbor depth
        //float zi	=	texture2D(DepthTexture, xy + coordi).r;
        float zi	=	fixDepth2(texture2D(DepthTexture, xy + coordi).r);
        float dz	=	(z - zi) / SigmaDepth;
        fi			*=	exp(-dz * dz / 2.0);
      }

      csum	+=	ci * fi;
      wsum	+=	fi;
    }
	}

	//output
	gl_FragColor = vec4(csum/wsum,1.0);
}

`;

export const makeDumpingTable = (halfSpatialSize: number, spatialSigma: number) => {
  const dampingPixelDistribution = new Float32Array(64);
  dampingPixelDistribution.fill(0);

  // constant quotient
  const q0 = halfSpatialSize * spatialSigma;
  const q = 2 * (q0 * q0);

  for (let c = 0; c <= halfSpatialSize; c += 1) {
    for (let d = 0; d <= halfSpatialSize; d += 1) {
      // dampingPixelDist[c * (halfSpatialSize + 1) + d] = Math.exp((c * c + d * d) / -q);
      const offset = c * (halfSpatialSize + 1) + d;
      const value = Math.exp(-(c * c + d * d) / q);
      dampingPixelDistribution[offset] = value;
    }
  }
  return dampingPixelDistribution;
};

interface BilateralFilterUniformProps {
  halfSpatialSize: number;
  screenSize: THREE.Vector2;
  isPerspective: boolean;
  zNear: number;
  zFar: number;
  depthSigma: number;
  spatialSigma: number;
  // colorTexture: THREE.Texture;
  // depthTexture: THREE.Texture;
}

export const makeBilateraFilterMaterial = (uniforms: BilateralFilterUniformProps) => {
  const shaderUniforms = {
    // DepthTexture: { type: 't', value: uniforms.depthTexture },
    // ColorTexture: { type: 't', value: uniforms.colorTexture },
    DepthTexture: { type: 't', value: null },
    ColorTexture: { type: 't', value: null },

    ScreenSize: { type: 'vec2', value: uniforms.screenSize },

    NHalf: { type: 'i', value: uniforms.halfSpatialSize },
    SigmaDepth: { type: 'f', value: uniforms.depthSigma },
    DistCoefs: { value: makeDumpingTable(uniforms.halfSpatialSize, uniforms.spatialSigma) },

    PerspectiveMode: { type: 'i', value: uniforms.isPerspective ? 1 : 0 },
    // zNear
    Znear: { type: 'f', value: uniforms.zNear },
    // zFar
    Zfar: { type: 'f', value: uniforms.zFar },
  };

  // console.log('bilateral', { shaderUniforms });

  return new THREE.ShaderMaterial({
    uniforms: shaderUniforms,
    vertexShader: bilateralVertexShader,
    fragmentShader: bilateralFragmentShader,
  });
};
